// Textos que se repetem no painel inteiro. Só entra aqui o que é genérico de
// verdade (verbo de botão, estado de carregamento); texto de uma tela fica no
// namespace da tela, mesmo que pareça igual a outro, porque a mesma palavra
// em português pode pedir traduções diferentes em contextos diferentes.
import { defineMessages } from '../core';

export const commonT = defineMessages('common', {
  pt: {
    appTitle: 'WindMaps - Eventos',
    save: 'Salvar',
    saving: 'Salvando...',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Fechar',
    back: 'Voltar',
    next: 'Próximo',
    edit: 'Editar',
    remove: 'Remover',
    delete: 'Excluir',
    add: 'Adicionar',
    copy: 'Copiar',
    copied: 'Copiado',
    retry: 'Tentar de novo',
    loading: 'Carregando...',
    yes: 'Sim',
    no: 'Não',
    search: 'Buscar',
    language: 'Idioma',
    notFoundTitle: 'Página não encontrada',
    notFoundBody: 'Verifique a URL ou volte para a home.',
    genericError: 'Algo deu errado.',
  },
  en: {
    appTitle: 'WindMaps - Events',
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    edit: 'Edit',
    remove: 'Remove',
    delete: 'Delete',
    add: 'Add',
    copy: 'Copy',
    copied: 'Copied',
    retry: 'Try again',
    loading: 'Loading...',
    yes: 'Yes',
    no: 'No',
    search: 'Search',
    language: 'Language',
    notFoundTitle: 'Page not found',
    notFoundBody: 'Check the URL or go back to the home page.',
    genericError: 'Something went wrong.',
  },
  es: {
    appTitle: 'WindMaps - Eventos',
    save: 'Guardar',
    saving: 'Guardando...',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Cerrar',
    back: 'Volver',
    next: 'Siguiente',
    edit: 'Editar',
    remove: 'Quitar',
    delete: 'Eliminar',
    add: 'Agregar',
    copy: 'Copiar',
    copied: 'Copiado',
    retry: 'Intentar de nuevo',
    loading: 'Cargando...',
    yes: 'Sí',
    no: 'No',
    search: 'Buscar',
    language: 'Idioma',
    notFoundTitle: 'Página no encontrada',
    notFoundBody: 'Revisa la URL o vuelve a la página de inicio.',
    genericError: 'Algo salió mal.',
  },
});
